import { get } from "../../utils/objectHelpers";

import StrAboutDescription from "<str-about-description>";
import StrBusinessDetails from "<str-business-details>";
import StrMarketingBanner from "<str-marketing-banner>";
import StrContactSeller from "<str-contact-seller>";
import StrItemsCarousel from "<str-items-carousel>";
import StrAboutPolicies from "<str-about-policies>";
import StrSellerComms from "<str-seller-comms>";
import StrAboutVideo from "<str-about-video>";
import StrItemsGrid from "<str-items-grid>";
import StrStatusModule from "<str-status>";
import StrDebug from "<str-debug>";

$ {
    const moduleComponents = {
        StrAboutDescription,
        StrBusinessDetails,
        StrMarketingBanner,
        StrContactSeller,
        StrItemsCarousel,
        StrAboutPolicies,
        StrStatusModule,
        StrSellerComms,
        StrAboutVideo,
        StrItemsGrid
    };
    const modulesRequiringFullRegions = [
        "StrAboutPolicies",
        "StrAboutVideo",
        "StrItemsGrid"
    ];
    const region = input.regionsData[input.region];
    const mainModules = get(input, 'regionsData.MAIN', []);
    const spinnerModule = mainModules.find(m => m.meta && m.meta.name === 'LOADING_SPINNER');
}

<if(region)>
    <for|module| of=region>
        <if(module)>
            <${module.__debug && StrDebug}
                __empty=!moduleComponents[module._uxComponent]
                module=module
            >
                <if(moduleComponents[module._uxComponent])>
                    $ {
                        const passedInput = modulesRequiringFullRegions
                            .find(component => component === module._uxComponent)
                                ? { regionsData: input.regionsData }
                                : module;

                        if (module._uxComponent === 'StrMarketingBanner') {
                            passedInput.spinnerModule = spinnerModule;
                        }
                    }
                    <${moduleComponents[module._uxComponent]} ...passedInput />
                </if>
            </>
        </if>
    </for>
</if>
